import styled from 'styled-components';
import { screen } from '@/helpers/screen';

export const SectionWrapper = styled.section`
  padding: 60px 0;
  background-color: ${({ theme }) => theme.color.neutral.lighter3};
  text-align: center;

  ${screen.lg} {
    padding: 100px 0;
  }
`;

export const TitleWrapper = styled.div`
  margin: 8px 0 48px;

  ${screen.md} {
    margin: 12px 0 48px;
  }

  ${screen.lg} {
    margin: 16px 0 48px;
  }

  ${screen.xxlg} {
    margin: 16px 0 64px;
  }
`;

export const MediaWrapper = styled.div`
  margin: auto;
  max-width: 315px;
  height: 220px;

  ${screen.md} {
    max-width: 690px;
    height: 387px;
  }

  ${screen.lg} {
    max-width: 826px;
    height: 534px;
  }

  ${screen.xxlg} {
    max-width: 1086px;
    height: 610px;
  }
`;
